import { ICanonicalMapper } from '../../Firestore/ICanonicalMapper'
import { IPriceListEntry, PriceListEntry } from './PriceListEntry'
import { BarcodeMapper } from '../..'

export class PriceListEntryMapper implements ICanonicalMapper {
  map(data: IPriceListEntry): PriceListEntry {
    const entry = new PriceListEntry(data.upc, data.description)

    entry.id = data.id
    entry.barcode = !data.barcode ? undefined : ( new BarcodeMapper() ).map(data.barcode)
    entry.orderingNotes = data.orderingNotes || undefined
    entry.category = data.category || undefined

    return entry
  }
}
